import React from 'react';
import QuestionWarnings from './QuestionWarnings';
import { getWordCount, isQuestionTooLong, isQuestionComplex } from '../utils/questionValidation';
import { QUESTION_TYPES, getTypeStyles, getTypeLabel } from '../utils/questionTypeStyles';

const QuestionControls = ({
  question,
  type,
  onTypeChange,
  activeTooltip,
  setActiveTooltip
}) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <select
          value={type || 'behavioral'}
          onChange={(e) => onTypeChange(e.target.value)}
          className={`text-sm border rounded px-2 py-1.5 ${getTypeStyles(type || 'behavioral')}`}
        >
          {Object.entries(QUESTION_TYPES).map(([value, { label }]) => (
            <option key={value} value={value}>{label}</option>
          ))}
        </select>

        <QuestionWarnings
          wordCount={getWordCount(question.text)}
          isQuestionTooLong={isQuestionTooLong(question.text, type)}
          isQuestionComplex={isQuestionComplex(question.text)}
          questionId={question.id}
          questionType={type}
          activeTooltip={activeTooltip}
          setActiveTooltip={setActiveTooltip}
        />
      </div>
    </div>
  );
};

export default QuestionControls; 